<template>
  <div :class="scope.clsPrefix">
    <template v-if="isDemo">
      <div class="detail-header">
        <span class="room-tag">{{ roomTag }}</span>
        <div class="header-title">{{ detailData.title || "暂无报告" }}</div>
        <div class="warning-text">
          {{
            detailData.summary ||
            ""  }}
        </div>
      </div>
      <div class="highlight-box">
        <div class="highlight-desc">
          {{
            detailData.content ||
            ""  }}
        </div>
      </div>
      <div class="highlight-tags">
        <span
          v-for="(tag, index) in detailData.tagsArray"
          :key="index"
          class="highlight-tag"
          >{{ tag }}</span
        >
      </div>

      <!-- <div class="section">
        <div class="section-title">重点结论</div>
        <div class="conclusion-list">
          <div v-for="(item, index) in detailData.conclusions" :key="index" class="enter-conclusion-item">
            <div class="conclusion-dot"></div>
            <div class="conclusion-content">
              <div class="conclusion-title">{{ item.title }}</div>
              <div v-if="item.desc" class="conclusion-desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="section">
        <div class="section-title">详细信息</div>
        <div class="enter-detail-grid">
          <div class="detail-card">
            <div class="detail-card-left">
              <div class="detail-label">报告类型</div>
              <div class="detail-desc">{{ detailData.reportTypeText }}</div>
            </div>
            <!-- <div class="detail-value">4.5万</div> -->
          </div>
          <div class="detail-card">
            <div class="detail-card-left">
              <div class="detail-label">数字人</div>
              <div class="detail-desc">{{ detailData.agentName }}</div>
            </div>
            <!-- <div class="detail-value">{{ detailData.impactText }}</div> -->
          </div>
          <div class="detail-card">
            <div class="detail-card-left">
              <div class="detail-label">创建时间</div>
              <div class="detail-desc">{{ detailData.createTime }}</div>
            </div>
            <!-- <div class="detail-value">{{ detailData.updateTime }}</div> -->
          </div>
        </div>
      </div>
    </template>
   <template v-else>
      <div class="detail-mini-header">
        <span class="room-tag">{{ roomTag }}</span>
        <div class="header-right">
          <!-- <button class="download-btn" type="button" @click="handleDownloadPdf">
            <i class="el-icon-download"></i> 下载
          </button> -->
          <!-- 文档模式：下拉选择 PDF / Word / Markdown -->
          <el-dropdown v-if="viewMode === 'doc'" trigger="click" @command="handleDownloadCommand">
            <div class="download-btn">
              <img src="@/assets/imgs/detail/download_icon.png" alt="" width="16" height="16">
              下载
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="pdf">PDF</el-dropdown-item>
              <el-dropdown-item command="word">Word</el-dropdown-item>
              <el-dropdown-item command="markdown">Markdown</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- 网页模式：直接下载 PDF -->
          <div v-else class="download-btn" @click="handleDownloadPdf">
            <img src="@/assets/imgs/detail/download_icon.png" alt="" width="16" height="16">
             下载
          </div>
          <!-- 智能分析按钮 -->
          <div class="action-btn-smart" @click="handleSmartAnalysis">
            <i class="el-icon-magic-stick"></i> 智能分析
          </div>
          <!-- 异常详情按钮：仅有异常时展示 -->
          <div v-if="detailData.hasAnomaly" class="action-btn-anomaly" @click="handleAnomalyDetail">
            <i class="el-icon-warning"></i> 异常详情
          </div>
          <div class="view-switch" :class="{ 'mode-web': viewMode === 'web', 'mode-doc': viewMode === 'doc' }">
            <div style="font-size: 12px" class="switch-tab tab-web" @click="viewMode = 'web'">网页</div>
            <div style="font-size: 12px" class="switch-tab tab-doc" @click="viewMode = 'doc'">文档</div>
          </div>
        </div>
      </div>
      <div ref="pdfContent" v-loading="loading" class="report-body">
        <div v-if="!loading && viewMode === 'doc' && renderedMarkdown" class="markdown-body" v-html="renderedMarkdown"></div>
        <!-- 网页模式：大模型生成的 HTML 经 DOMPurify 净化并挂入 Shadow DOM，隔离样式与脚本 -->
        <SafeHtmlRenderer v-else-if="!loading && viewMode === 'web' && contentHtml" class="html-body" :html="contentHtml" @rendered="onSafeHtmlRendered" />
        <!-- 空状态：加载完成后仍无任何报告内容时的友好提示 -->
        <div v-else-if="!loading" class="report-empty">
          <img class="report-empty__img" src="@/assets/imgs/empty/empty.png" alt="暂无数据">
          <div class="report-empty__title">暂无报告内容</div>
          <div class="report-empty__desc">当前报告暂无可展示的数据</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { renderMarkdownText } from '@/utils/markdownRenderer'
import mermaid from 'mermaid'
// eslint-disable-next-line no-unused-vars
import { downloadPdf, downloadHtmlAsPdf, downloadWord, downloadMarkdown } from '@/utils/pdfDownload'
import { getJobReportDetailApi } from '@/api/agentAuth'
import SafeHtmlRenderer from '@/components/SafeHtmlRenderer/index.vue'
export default {
  name: 'EnterpriseDetail',
  components: {
    SafeHtmlRenderer
  },
  props: {
    id: {
      type: [Number, String],
      default: null
    },
    roomTag: {
      type: String,
      default: '企业战情室'
    },
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-enterprise-detail'
      },
      detailData: {},
      renderedMarkdown: '',
      content: '',
      viewMode: 'doc',
      loading: false,
      contentHtml: '',
      // 网页模式经 DOMPurify 净化后的 HTML，供下载时构造离屏 DOM 复用
      sanitizedContentHtml: ''
    }
  },
  computed: {
    isDemo() {
      return !this.id
    }
  },
  created() {
    this.fetchDetail()
  },
  watch: {
    id() {
      this.fetchDetail()
    }
  },
  methods: {
    // SafeHtmlRenderer 渲染完成后回传净化后的 HTML，缓存供下载使用
    onSafeHtmlRendered(sanitizedHtml) {
      this.sanitizedContentHtml = sanitizedHtml || ''
    },
    // 智能分析：向上 emit，由父组件复用 handleSmartAnalysis 逻辑
    handleSmartAnalysis() {
      this.$emit('smart-analysis', this.detailData)
    },
    // 异常详情：向上 emit，由父组件打开 AnomalyDetailDialog
    handleAnomalyDetail() {
      this.$emit('anomaly-detail', this.detailData)
    },
    async handleDownloadPdf() {
      const title = (this.detailData && this.detailData.title) || '报告详情'

      // 网页模式：内容渲染在 Shadow DOM 内，html2canvas 无法穿透，
      // 用离屏 iframe 承载净化后的 HTML（独立文档、坐标从 0 开始、尺寸自洽），再截图导出。
      if (this.viewMode === 'web') {
        const html = this.sanitizedContentHtml || ''
        if (!html) {
          this.$message.warning('暂无报告内容可下载')
          return
        }
        await downloadHtmlAsPdf(html, title + '.pdf')
        return
      }

      // 文档模式：截取真实 DOM（保持原有逻辑不变）
      const el = this.$refs.pdfContent
      if (!el) {
        this.$message.warning('暂无报告内容可下载')
        return
      }
      await downloadPdf(el, title + '.pdf')
    },
    // 文档模式下拉下载命令分发
    handleDownloadCommand(command) {
      const title = (this.detailData && this.detailData.title) || '报告详情'
      if (command === 'pdf') {
        this.handleDownloadPdf()
      } else if (command === 'word') {
        this.handleDownloadWord(title)
      } else if (command === 'markdown') {
        this.handleDownloadMarkdown(title)
      }
    },
    // 文档模式 → Word：用渲染后的 HTML 转换
    handleDownloadWord(title) {
      const html = this.renderedMarkdown
      if (!html) {
        this.$message.warning('暂无报告内容可下载')
        return
      }
      downloadWord(html, title + '.doc')
    },
    // 文档模式 → Markdown：用原始 markdown 源文
    handleDownloadMarkdown(title) {
      if (!this.content) {
        this.$message.warning('暂无报告内容可下载')
        return
      }
      downloadMarkdown(this.content, title + '.md')
    },
    async fetchDetail() {
      // debugger
      if (!this.id) {
        this.detailData = {}
        this.loading = false
        return
      }
      this.loading = true
      try {
        const res = await getJobReportDetailApi(this.id)
        if (res && res.data) {
          this.detailData = this.transformData(res.data)
          this.content = res.data.content || ''
          this.renderedMarkdown = renderMarkdownText(res.data.content || '')
          this.contentHtml = res.data.contentHtml || ''
          this.$nextTick(() => this._initMermaid())
        } else {
          this.detailData = {}
          this.content = ''
          this.renderedMarkdown = ''
          this.contentHtml = ''
        }
      } catch (error) {
        console.error('获取企业战情室报告详情失败:', error)
        this.detailData = {}
        this.content = ''
        this.renderedMarkdown = ''
        this.contentHtml = ''
      } finally {
        this.loading = false
      }
    },
    transformData(data) {
      const tagsArray = data.tags
        ? data.tags.split(',').map((t) => t.trim())
        : []
      const conclusions = this.parseConclusions(data.content || data.summary)

      return {
        id: data.id,
        title: data.title,
        summary: data.summary,
        content: data.content,
        tags: data.tags,
        tagsArray: tagsArray,
        hasAnomaly: data.hasAnomaly || false,
        anomalyDispositionStatus: data.anomalyDispositionStatus || '',
        desc: data.summary || data.desc || '',
        category: data.category,
        categoryText: this.getCategoryText(data.category),
        impactLevel: data.impactLevel,
        impactText: this.getImpactText(data.impactLevel),
        reportType: data.reportType,
        reportTypeText: this.getReportTypeText(data.reportType),
        agentName: data.agentName || 'CEO数字人',
        createTime: data.createTime || '',
        updateTime: data.updateTime || '',
        conclusions: conclusions
      }
    },
    parseConclusions(content) {
      if (!content) {
        return []
      }
      const lines = content.split(/[\n\r]+/).filter((line) => line.trim())
      return lines.map((line) => ({
        title: line.substring(0, 50),
        desc: line.length > 50 ? line : ''
      }))
    },
    getCategoryText(category) {
      const map = { internal: '内部报告', external: '外部报告' }
      return map[category] || '内部报告'
    },
    getImpactText(level) {
      if (level >= 5) return '负向影响'
      return '正向影响'
    },
    getReportTypeText(type) {
      const map = { market: '市场行情', policy: '政策法规', competitor: '竞品动态' }
      return map[type] || '市场行情'
    },
    _initMermaid() {
      const container = this.$refs.pdfContent
      if (!container) return
      const blocks = container.querySelectorAll('.mermaid-block__body')
      blocks.forEach(async (body) => {
        const block = body.closest('.mermaid-block')
        if (!block) return
        // 已被全局 MutationObserver 渲染过的跳过，避免重复渲染
        if (block.dataset.mermaidRendered === '1') return
        const encoded = block.getAttribute('data-mermaid')
        if (!encoded) return
        try {
          const code = decodeURIComponent(encoded)
          const { svg } = await mermaid.render('mm-' + Math.random().toString(36).slice(2), code)
          body.innerHTML = svg
          block.dataset.mermaidRendered = '1'
        } catch (e) {
          body.innerHTML = '<div class="mermaid-error">图表渲染失败</div>'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-enterprise-detail";

.#{$class-prefix} {
  padding: 24px;
  padding-top: 0;
  background: #fff;
  border-radius: 8px;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  scrollbar-width: thin;
  scrollbar-color: #eee transparent;
  position: relative;
}
.#{$class-prefix}::-webkit-scrollbar {
  width: 4px;
}
.#{$class-prefix}::-webkit-scrollbar-track {
  background: transparent;
}
.#{$class-prefix}::-webkit-scrollbar-thumb {
  background: #fff;
  border-radius: 2px;
}
.detail-header {
  margin-bottom: 32px;
}
.room-tag {
  width: 84px;
  height: 24px;
  background-image: linear-gradient(270deg, #4a5ff3 0%, #67b7f9 100%);
  box-shadow: inset 0 0 8px 0 #ffffff80;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
  margin-bottom: 12px;
}
.header-title {
  font-weight: 600;
  font-size: 24px;
  color: #333333;
  font-family: PingFangSC-Medium;
  margin-bottom: 8px;
}
.warning-text {
  font-family: PingFangSC-Medium;
  font-weight: 600;
  font-size: 14px;
  color: #000000;
}
.highlight-box {
  height: 72px;
  background: #ffffff;
  border: 1px solid #4a5ff3;
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 12px 23px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #4a5ff3;
  line-height: 24px;
  margin-bottom: 12px;
}
.highlight-desc {
  // font-size: 14px;
  // color: #333;
  // line-height: 1.6;
  // font-family: PingFangSC-Regular;
  // margin-bottom: 12px;
}
.highlight-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 32px;
}
.highlight-tag {
  height: 22px;
  border: 1px solid #dddddd;
  border-radius: 2px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #333333;
  padding: 3px 8px;
}
.section {
  margin-bottom: 32px;
}
.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  font-family: PingFangSC-Medium;
}
.core-indicators {
  height: 64px;
  display: flex;
  gap: 10px;
}
.indicator-card {
  flex: 1;
  padding: 0 24px;
  background: #edf1fb;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  &.positive {
    .indicator-value {
      color: #4caf50;
    }
  }
}
.enter-indicator-label {
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 12px;
  color: #595959;
}
.indicator-value {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  font-family: PingFangSC-Medium;
}
.value-unit {
  font-size: 12px;
  font-weight: 600;
  color: #333;
}
.conclusion-list {
  border: 1px solid #edf1fb;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
}
.enter-conclusion-item {
  display: flex;
  gap: 16px;
  // padding: 14px;
  // background: #FAFBFC;
  // border-radius: 8px;
}
.conclusion-dot {
  width: 8px;
  height: 8px;
  background: #4a5ff3;
  border-radius: 50%;
  margin-top: 6px;
  flex-shrink: 0;
}
.conclusion-content {
  flex: 1;
}
.conclusion-title {
  font-size: 14px;
  font-weight: 600;
  color: #4a5ff3;
  margin-bottom: 6px;
  font-family: PingFangSC-Medium;
}
.conclusion-desc {
  font-size: 14px;
  color: #333;
  font-family: PingFangSC-Medium;
}
.enter-detail-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}
.detail-card {
  padding: 16px 24px;
  height: 70px;
  border: 1px solid #edf1fb;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.detail-label {
  font-size: 14px;
  color: #4a5ff3;
  font-weight: 600;
  margin-bottom: 4px;
  font-family: PingFangSC-Medium;
}
.detail-desc {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #aaaaaa;
}
.detail-value {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  font-family: PingFangSC-Bold;
}
.header-right {
  display: inline-flex;
  align-items: center;
  gap: 16px;
  /* 相对 sticky 头部(.detail-mini-header)定位，随头部一起固定 */
  position: absolute;
  top: 24px;
  right: 24px;
}

.view-switch {
  display: inline-flex;
  height: 24px;
  position: relative;
  border-radius: 4px;
  overflow: visible;
}

.switch-tab {
  width: 60px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  cursor: pointer;
  user-select: none;
  transition: all 0.25s ease;
  position: relative;
}

.switch-tab.tab-web {
  background: #eef4ff;
  color: #666;
  clip-path: polygon(0 0, 100% 0, 90% 100%, 0 100%);
  border-radius: 4px 0 0 4px;
}

.switch-tab.tab-doc {
  background: #eef4ff;
  color: #666;
  clip-path: polygon(10% 0, 100% 0, 100% 100%, 0 100%);
  border-radius: 0 4px 4px 0;
  margin-left: -6px;
}

.view-switch.mode-web .tab-web {
  background: #4a5ff3;
  color: #fff;
  z-index: 1;
}

.view-switch.mode-web .tab-doc {
  background: #f5f7fa;
  color: #999;
}

.view-switch.mode-doc .tab-doc {
  background: #4a5ff3;
  color: #fff;
  z-index: 1;
}

.view-switch.mode-doc .tab-web {
  background: #f5f7fa;
  color: #999;
}

.html-body {
  line-height: 1.8;
  color: #333;
}

.detail-mini-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #fff;
  /* 负 margin 把白底横向铺满容器 24px 内边距，遮挡上滚正文；顶部覆盖圆角边缘 */
  margin: -24px -24px 24px;
  padding: 24px 24px 12px;
  border-radius: 8px 8px 0 0;
}

.download-btn {
  // float: right;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  // padding: 6px 16px;
  border: none;
  border-radius: 4px;
  // background: #4a5ff3;
  color: #4A5FF3;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  width: 72px;
  height: 24px;
  border: 1px solid #4A5FF3;
  border-radius: 4px;
}

// 智能分析按钮
.action-btn-smart {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  padding: 0 10px;
  font-size: 12px;
  color: #4A5FF3;
  border: 1px solid #4A5FF3;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    background: #4A5FF3;
    color: #fff;
  }

  i {
    font-size: 13px;
  }
}

// 异常详情按钮
.action-btn-anomaly {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 24px;
  padding: 0 10px;
  font-size: 12px;
  color: #e54b3d;
  border: 1px solid #e54b3d;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    background: #e54b3d;
    color: #fff;
  }

  i {
    font-size: 13px;
  }
}

// .download-btn:hover {
//   background: #3a4fe3;
// }

.markdown-body.html-body {
  line-height: 1.85;
  color: #333;
  font-size: 12px;
}
.html-body {
  width: 100%;
}
.markdown-body ::v-deep h1 {
  margin-top: 24px;
  margin-bottom: 12px;
  font-weight: 600;
  color: #1a1a1a;
  font-size: 18px;
}
.markdown-body ::v-deep h2 {
  margin-top: 20px;
  margin-bottom: 10px;
  font-weight: 600;
  color: #1a1a1a;
  font-size: 15px;
}
.markdown-body ::v-deep h3 {
  margin-top: 16px;
  margin-bottom: 8px;
  font-weight: 600;
  color: #1a1a1a;
  font-size: 13px;
}
.markdown-body ::v-deep h4,
.markdown-body ::v-deep h5,
.markdown-body ::v-deep h6 {
  margin-top: 12px;
  margin-bottom: 6px;
  font-weight: 600;
  color: #1a1a1a;
  font-size: 12px;
}
.markdown-body ::v-deep p {
  margin-bottom: 12px;
  line-height: 1.85;
  font-size: 12px;
}
.markdown-body ::v-deep ul,
.markdown-body ::v-deep ol {
  margin-bottom: 12px;
  padding-left: 24px;
  font-size: 12px;
}
.markdown-body ::v-deep li {
  line-height: 2.0;
  margin: 6px 0;
  font-size: 12px;
}
.markdown-body ::v-deep table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 12px;
  font-size: 12px;
}
.markdown-body ::v-deep th,
.markdown-body ::v-deep td {
  border: 1px solid #e8ecf0;
  padding: 6px 10px;
  text-align: left;
  font-size: 12px;
}
.markdown-body ::v-deep th {
  background: #f5f7ff;
  font-weight: 600;
}
.markdown-body ::v-deep strong {
  font-weight: 600;
}

/* GFM task list checkbox */
.markdown-body ::v-deep li > input[type="checkbox"] {
  all: unset;
  display: inline-block;
  -webkit-appearance: checkbox;
  appearance: checkbox;
  width: 14px;
  height: 14px;
  margin: 3px 8px 0 0;
  vertical-align: middle;
  accent-color: #67C23A;
  cursor: default;
  flex-shrink: 0;
}
.markdown-body ::v-deep li:has(> input[type="checkbox"]) {
  display: flex;
  align-items: flex-start;
}

/* 空状态：图标 + 提示文字，垂直居中留白 */
.report-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px 96px;
  text-align: center;
}
.report-empty__img {
  width: 240px;
  height: auto;
  margin-bottom: 20px;
  user-select: none;
  pointer-events: none;
}
.report-empty__title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  line-height: 1.5;
}
.report-empty__desc {
  margin-top: 8px;
  font-size: 13px;
  color: #999;
  line-height: 1.5;
}

/* 内容容器：预留最小高度，保证加载中 v-loading 遮罩有可见区域 */
.report-body {
  min-height: 240px;
}
</style>

<style lang="scss">
@import '@/assets/styles/report-markdown.scss';
</style>
